<script>
  import { facilities, searchTerm } from './stores.js';
</script>

<!-- search -->
<div
  class="search-input flex z-999 absolute top-1 left-unset-ns left-4 right-2-ns shadow-2 br-pill pv1 ph2 bg-white items-center w-60 w-auto-ns mr3-ns"
>
  <img src="magnifying-glass.svg" alt="search" class="ph2" />
  <form
    class="w-100"
    on:submit={(e) => {
      e.preventDefault();
      e.stopPropagation();
      const fd = new FormData(e.target);
      const term = fd.get('searchTerm');
      searchTerm.set(term);
      facilities.search(term);
    }}
  >
    <input
      on:keyup={(e) => {
        if (
          (e.target.value.length >= 3 &&
            !e.altKey &&
            !e.ctrlKey &&
            !e.metaKey &&
            !e.shiftKey &&
            e.key !== 'Enter') ||
          e.target.value.length === 0
        ) {
          // console.log(e.target.value, e.target.value.length);
          searchTerm.set(e.target.value);
          facilities.search(e.target.value);
        }
      }}
      class="pa2 TIMono w5 w-100 bn f6 f5-ns"
      id="searchInput"
      type="text"
      name="searchTerm"
      placeholder="Facility or Location"
    /><button type="submit" class="dn pa2 ba bw1 b--black TIMono">Search</button
    >
    {#if $searchTerm}
      <button
        class="dn"
        type="button"
        on:click={(e) => {
          document.querySelector('#searchInput').value = '';
          facilities.reset();
          searchTerm.set('');
        }}>Clear</button
      >
    {/if}
  </form>
  {#if $searchTerm}
    <img
      src="TI_Cross_Dark.svg"
      alt="close"
      class="ph2 h1 w1 pointer"
      on:click={(e) => {
        document.querySelector('#searchInput').value = '';
        facilities.reset();
        searchTerm.set('');
      }}
    />
  {/if}
</div>
<!-- search -->
